// extracted by mini-css-extract-plugin
export var box = "MoreSpeakersCard-module--box--a6d9b";
export var box_md = "MoreSpeakersCard-module--box_md--b853e";
export var box_xmd = "MoreSpeakersCard-module--box_xmd--85978";
export var box_flex = "MoreSpeakersCard-module--box_flex--a2443";
export var box_lg = "MoreSpeakersCard-module--box_lg--3608e";
export var box_sm = "MoreSpeakersCard-module--box_sm--9f793";
export var box_outer = "MoreSpeakersCard-module--box_outer--211dd";
export var box_whiteBg = "MoreSpeakersCard-module--box_white-bg--924b5";
export var box_noMarginBottom = "MoreSpeakersCard-module--box_no-margin-bottom--e5ac0";
export var box_noPadding = "MoreSpeakersCard-module--box_no-padding--12db2";
export var box_outerGray = "MoreSpeakersCard-module--box_outer-gray--a55c3";
export var box_dark = "MoreSpeakersCard-module--box_dark--a753a";
export var box_zIndex = "MoreSpeakersCard-module--box_z-index--e1aa3";
export var box_zIndex6 = "MoreSpeakersCard-module--box_z-index-6--c3d53";
export var box_eventsWithLine = "MoreSpeakersCard-module--box_events-with-line--4a659";
export var box_featuresAo = "MoreSpeakersCard-module--box_features-ao--b8706";
export var box_verticalPaddings = "MoreSpeakersCard-module--box_vertical-paddings--32b04";
export var clearP = "MoreSpeakersCard-module--clearP--8fc77";
export var clearP_vc = "MoreSpeakersCard-module--clearP_vc--90ecd";
export var regular = "MoreSpeakersCard-module--regular--cbce6";
export var wide = "MoreSpeakersCard-module--wide--ee5d5";
export var title = "MoreSpeakersCard-module--title--4c1a5";
export var description = "MoreSpeakersCard-module--description--be702";
export var fadeInAnimation = "MoreSpeakersCard-module--fadeInAnimation--f086e";
export var placeHolderShimmer = "MoreSpeakersCard-module--placeHolderShimmer--dc7df";